import groupBy from 'lodash/groupBy';
import i18next from 'i18next';

/**
 * Group product lines by category, the display every order table shares: one group per product
 * category, categories in alphabetical order and products in alphabetical order inside a group.
 * Uncategorized products land in a single "Aucune" group, sorted with the others.
 *
 * @param {Array<Object>} productLines - The lines to group, each carrying `category` and `name`
 *
 * @returns {Array<{ category: string, products: Array<Object> }>}
 */
export const groupProductLinesByCategory = (productLines) => {
  const productsByCategory = groupBy(
    productLines,
    ({ category }) => category || i18next.t('GENERAL.NONE_VALUE'),
  );

  return Object.keys(productsByCategory)
    .sort((firstCategory, secondCategory) => firstCategory.localeCompare(secondCategory))
    .map((category) => ({
      category,
      products: productsByCategory[category].sort((firstProduct, secondProduct) =>
        (firstProduct.name ?? '').localeCompare(secondProduct.name ?? ''),
      ),
    }));
};
